import React, { useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import moment from "moment";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

export const DateFieldComp = props => {
  const classes = useStyles();

  const { field, index, handleBlur, inputProps, setReference, setReferenceToRequiredFunction } = props;

  const [required, setRequired] = useState(field.details.required === "REQUIRED");
  const [value, setValue] = useState(field.mappedValue ? moment(field.mappedValue) : null);
  const [hasInternalError, setHasInternalError] = useState(false);

  const formatValue = value => (value ? moment(value).format("MM-DD-YYYY") : null);

  setReference(field.lenderProperty, v => {
    setValue(v ? moment(v) : null);
    handleBlur(v, index);
  });

  setReferenceToRequiredFunction(field.lenderProperty, setRequired);

  const isRequiredError = required && !value;
  const isAnyError = hasInternalError || isRequiredError;

  return (
    <LocalizationProvider dateAdapter={AdapterMoment} key={index}>
      <DatePicker
        sx={{ width: "100%" }}
        label={(required ? "* " : "") + field.details.displayName}
        value={value}
        onChange={val => setValue(val)}
        onError={reason => {
          setHasInternalError(!!reason); // reason comes from the mui date picker, if it exists then set hasInternalError to true
        }}
        slotProps={{
          textField: {
            error: isAnyError, // our full error logic here
            className: classes.textField,
            onBlur: () => handleBlur(formatValue(value), index),
          },
        }}
      />
    </LocalizationProvider>
  );
};

const useStyles = makeStyles({
  textField: {
    margin: "8px 0",
    width: "100%",
    height: 40,

    "& input": {
      padding: 12,
      fontSize: 14,
    },
    "& .MuiOutlinedInput-input": {
      padding: "12px 24px",
    },
    "& .Mui-error fieldset": {
      borderColor: "#f44336 !important",
    },
    "& fieldset legend span": {
      fontSize: 12,
      fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
      textTransform: "none",
      fontWeight: "normal",
    },
  },
});
